export const danger = () => (
  <path
    d="M12 8v4m0 4h.01M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
